import addNotification from "react-push-notification";
import { onClickType } from "react-push-notification/dist/notifications/Storage";
import { cookieService } from "./CookieService";
import { utils } from "../utils";
import { DetectEnvironment } from "../EnvironmentSettings";
import history from "../app/history";
const { detect } = require("detect-browser");

const browser = detect();

class PushNotificationService {
    showNotification = (title: string, message: string, ForceFullyGenerated = false) => {
        var settingCookies = cookieService.getSettingsCookies();

        if (settingCookies?.chatNotifications === false && ForceFullyGenerated == false && !message?.includes("applied break")) {
            return
        }

        if (browser.os == "iOS") {
            return;
        }

        if (Notification.permission !== "granted") {
            Notification.requestPermission();
        }

        if (message == "" || message == null || message == undefined) {
            return;
        }


        if (!utils.isElectronBuild()) {
            addNotification({
                title: title,
                duration: 8000,
                message: message,
                native: true,
                icon: process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_NOTIFICATION_LOGO,
                theme: "red",
                backgroundTop: "green", //optional, background color of top container.
                backgroundBottom: "darkgreen", //optional, background color of bottom container.
                colorTop: "green", //optional, font color of top container.
                colorBottom: "darkgreen", //optional, font color of bottom container.
                closeButton: "Go away",
                // onClick:(e)=>{
                //     history.push("http://localhost:3000/#/monitoringPanel")
                //     window.location.reload();
                // }
            });
        } else {
            window?.myAPI?.PushNotification(title + ":" + message);
        }

    };
}
var notificationService = new PushNotificationService();

export { notificationService };
